/**
 * @generated SignedSource<<614722153aca82d9dabeb40fc48ec31c>>
 * @relayHash ddee5bcc7d51d2ed5555d8cc6f48ec88
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 28d394c12f422131aed5b9fb5279cc5096ef0d8e677d3789fcf89b22b34d31b6

import type { ConcreteRequest } from 'relay-runtime';
export type LicenseStatus = "ACTIVE" | "SUSPENDED" | "UNLICENSED" | "%future added value";
export type preloadTemplatesCollectionEligibleQuery$variables = Record<PropertyKey, never>;
export type preloadTemplatesCollectionEligibleQuery$data = {
  readonly confluence_tenantContext: {
    readonly licensedProducts: ReadonlyArray<{
      readonly licenseStatus: LicenseStatus;
      readonly productKey: string;
    }>;
  } | null;
  readonly onboardingState: ReadonlyArray<{
    readonly key: string;
    readonly value: string | null;
  }> | null;
  readonly user: {
    readonly confluence: {
      readonly hasPersonalSpace: boolean | null;
      readonly space: {
        readonly id: string | null;
        readonly key: string | null;
      } | null;
    } | null;
    readonly id: string | null;
    readonly team: string | null;
  } | null;
};
export type preloadTemplatesCollectionEligibleQuery = {
  response: preloadTemplatesCollectionEligibleQuery$data;
  variables: preloadTemplatesCollectionEligibleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "key"
},
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "key",
        "value": [
          "templates-collection:isTaggedForTemplatesCollectionExperiment",
          "templates-collection:isTemplatesSectionDismissed",
          "onboarding-state:introWorkflow",
          "onboarding-state:legacy",
          "onboarding-state:isFoundingAdmin",
          "onboarding-state:isSampleContentV2SpotlightVisible",
          "onboarding-state:landOnPath",
          "onboarding-state:teamSpaceCreated",
          "onboarding-state:isMoreActionsTourVisible",
          "onboarding-state:isMoreActionsHintVisible",
          "onboarding-state:improvedGetStartedPath",
          "onboarding-state:improvedGetStartedWhiteboardPath",
          "onboarding-state:nthUserGSPagePath",
          "onboarding-state:isRedactionsTourVisible",
          "onboarding-state:xflowSpaceCreated",
          "onboarding-state:templateOnboardingViewedTime",
          "onboarding-state:nthUserOnboardingCompletedTimestamp",
          "onboarding-state:nthUserOnboardingFlagViewed",
          "onboarding-state:nthUserOnboardingPageViewed",
          "onboarding-state:nthUserBannerDismissed"
        ]
      }
    ],
    "concreteType": "OnboardingState",
    "kind": "LinkedField",
    "name": "onboardingState",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ],
    "storageKey": "onboardingState(key:[\"templates-collection:isTaggedForTemplatesCollectionExperiment\",\"templates-collection:isTemplatesSectionDismissed\",\"onboarding-state:introWorkflow\",\"onboarding-state:legacy\",\"onboarding-state:isFoundingAdmin\",\"onboarding-state:isSampleContentV2SpotlightVisible\",\"onboarding-state:landOnPath\",\"onboarding-state:teamSpaceCreated\",\"onboarding-state:isMoreActionsTourVisible\",\"onboarding-state:isMoreActionsHintVisible\",\"onboarding-state:improvedGetStartedPath\",\"onboarding-state:improvedGetStartedWhiteboardPath\",\"onboarding-state:nthUserGSPagePath\",\"onboarding-state:isRedactionsTourVisible\",\"onboarding-state:xflowSpaceCreated\",\"onboarding-state:templateOnboardingViewedTime\",\"onboarding-state:nthUserOnboardingCompletedTimestamp\",\"onboarding-state:nthUserOnboardingFlagViewed\",\"onboarding-state:nthUserOnboardingPageViewed\",\"onboarding-state:nthUserBannerDismissed\"])"
  },
  {
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "concreteType": "LicensedProduct",
        "kind": "LinkedField",
        "name": "licensedProducts",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "licenseStatus"
          },
          {
            "kind": "ScalarField",
            "name": "productKey"
          }
        ]
      }
    ]
  },
  {
    "alias": "user",
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "name": "team"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasPersonalSpace"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v0/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "preloadTemplatesCollectionEligibleQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "preloadTemplatesCollectionEligibleQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ddee5bcc7d51d2ed5555d8cc6f48ec88",
    "id": "28d394c12f422131aed5b9fb5279cc5096ef0d8e677d3789fcf89b22b34d31b6",
    "metadata": {},
    "name": "preloadTemplatesCollectionEligibleQuery",
    "operationKind": "query",
    "text": "query preloadTemplatesCollectionEligibleQuery{onboardingState(key:[\"templates-collection:isTaggedForTemplatesCollectionExperiment\",\"templates-collection:isTemplatesSectionDismissed\",\"onboarding-state:introWorkflow\",\"onboarding-state:legacy\",\"onboarding-state:isFoundingAdmin\",\"onboarding-state:isSampleContentV2SpotlightVisible\",\"onboarding-state:landOnPath\",\"onboarding-state:teamSpaceCreated\",\"onboarding-state:isMoreActionsTourVisible\",\"onboarding-state:isMoreActionsHintVisible\",\"onboarding-state:improvedGetStartedPath\",\"onboarding-state:improvedGetStartedWhiteboardPath\",\"onboarding-state:nthUserGSPagePath\",\"onboarding-state:isRedactionsTourVisible\",\"onboarding-state:xflowSpaceCreated\",\"onboarding-state:templateOnboardingViewedTime\",\"onboarding-state:nthUserOnboardingCompletedTimestamp\",\"onboarding-state:nthUserOnboardingFlagViewed\",\"onboarding-state:nthUserOnboardingPageViewed\",\"onboarding-state:nthUserBannerDismissed\"]){key,value},confluence_tenantContext{licensedProducts{licenseStatus,productKey}},user:confluence_atlassianUser{id,team,confluence{hasPersonalSpace,space{id,key}}}}"
  }
};
})();

(node as any).hash = "2e478de184cf22dbf9c640f31ec7f723";

export default node;
